import React from "react";
import { Dialog, DialogType, DialogFooter, PrimaryButton, DefaultButton, Checkbox, Stack, TextField } from "@fluentui/react";
import FeedbackOptionConstants from "../../../constants/FeedbackOptionConstants";

interface LikeFeedbackProps {
  isVisible: boolean;
  onDismiss: () => void;
  onSubmit: (options: string[], feedback: string) => void;
  selectedOptions: string[];
  setSelectedOptions: React.Dispatch<React.SetStateAction<string[]>>;
  feedback: string;
  setFeedback: React.Dispatch<React.SetStateAction<string>>;
}



const LikeFeedback: React.FC<LikeFeedbackProps> = ({
  isVisible,
  onDismiss,
  onSubmit,
  selectedOptions,
  setSelectedOptions,
  feedback,
  setFeedback
}) => {
  return (
    <Dialog
      hidden={!isVisible}
      onDismiss={onDismiss}
      dialogContentProps={{
        type: DialogType.largeHeader,
        title: 'Like Feedback',
        subText: 'Please select a reason for liking this response:',
      }}
    >
      <Stack tokens={{ childrenGap: 10 }}>
        {FeedbackOptionConstants.likeOptions.map(option => (
          <Checkbox
            key={option.key}
            label={option.text}
            onChange={(e, checked) => {
              if (checked) setSelectedOptions([...selectedOptions, option.key]);
              else setSelectedOptions(selectedOptions.filter(k => k !== option.key));
            }}
          />
        ))}
      </Stack>
      {selectedOptions.includes('other') && (
        <TextField
          label="Feedback"
          multiline
          rows={3}
          value={feedback}
          onChange={(e, newValue) => setFeedback(newValue || '')}
        />
      )}
      <DialogFooter>
        <PrimaryButton text="Submit" onClick={() => onSubmit(selectedOptions, feedback)} />
        <DefaultButton text="Cancel" onClick={onDismiss} />
      </DialogFooter>
    </Dialog>
  );
};

export default LikeFeedback;
